module.exports = __webpack_public_path__ + "static/istishia-jergal-gwaeron_windstrom-hoar-milil-DND3_FnP-b286d7e298595f40cbc299e0218d3d44.webp";